// extracted by mini-css-extract-plugin
export default {"mainContainer":"onboarding_mainContainer__8JW-W"};